export interface ApplicationTypeProps {
  applicationTypeName?: string;
  programId?: number;
  id: number;
  termsAndConditionsHtml?: string;
}

export enum ApplicationTypes {
  Standard = 1,
  StateQuestions = 2,
  GrowthAward = 3,
}

export function applicationTypeAsString(appType: ApplicationTypes): string {
  switch (appType) {
    case ApplicationTypes.Standard:
      return 'Standard';
    case ApplicationTypes.StateQuestions:
      return 'State Questions';
    case ApplicationTypes.GrowthAward:
      return 'Growth Award';
    default:
      return 'Standard';
  }
}
